import { render, staticRenderFns } from "./Highlight.vue?vue&type=template&id=c1069436&"
import script from "./Highlight.vue?vue&type=script&lang=js&"
export * from "./Highlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports